/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../data';
import '../../common/calendar/calendar';
import '../time_calculation';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "timecards": {
        "nested": {
          "scheduling": {
            "nested": {
              "OpenShiftsFilter": {
                "values": {
                  "INCLUDE": 0,
                  "EXCLUDE": 1,
                  "ONLY": 2
                }
              },
              "ColorScheme": {
                "values": {
                  "DO_NOT_USE": 0,
                  "LIGHT_LIME": 1,
                  "DARK_LIME": 2,
                  "LIGHT_TEAL": 3,
                  "DARK_TEAL": 4,
                  "LIGHT_BLUE": 5,
                  "DARK_BLUE": 6,
                  "LIGHT_PURPLE": 7,
                  "DARK_PURPLE": 8,
                  "LIGHT_PLUM": 9,
                  "DARK_PLUM": 10,
                  "LIGHT_ROSE": 11,
                  "DARK_ROSE": 12,
                  "LIGHT_ORANGE": 13,
                  "DARK_ORANGE": 14
                }
              },
              "Shift": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "shiftSchedule": {
                    "type": ".squareup.timecards.scheduling.ShiftSchedule",
                    "id": 2,
                    "rule": "optional"
                  },
                  "timecard": {
                    "type": ".squareup.timecards.Timecard",
                    "id": 3,
                    "rule": "optional"
                  },
                  "timecardBreaks": {
                    "type": ".squareup.timecards.TimecardBreak",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "traits": {
                    "type": ".squareup.timecards.scheduling.Shift.Traits",
                    "id": 4,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Traits": {
                    "fields": {
                      "status": {
                        "type": ".squareup.timecards.scheduling.Shift.Traits.Status",
                        "id": 1,
                        "rule": "optional"
                      },
                      "isUnscheduled": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Status": {
                        "values": {
                          "DO_NOT_USE": 0,
                          "SCHEDULED": 1,
                          "IN_PROGRESS": 2,
                          "COMPLETED": 3
                        }
                      }
                    }
                  }
                }
              },
              "ShiftSchedule": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "shiftId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "merchantId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "colorScheme": {
                    "type": ".squareup.timecards.scheduling.ColorScheme",
                    "id": 9,
                    "rule": "optional",
                    "options": {
                      "default": "LIGHT_BLUE"
                    }
                  },
                  "latestVersion": {
                    "type": ".squareup.timecards.scheduling.ShiftSchedule.Version",
                    "id": 4,
                    "rule": "optional"
                  },
                  "publishedVersion": {
                    "type": ".squareup.timecards.scheduling.ShiftSchedule.Version",
                    "id": 5,
                    "rule": "optional"
                  },
                  "deleted": {
                    "type": "bool",
                    "id": 8,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "updatedAt": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Version": {
                    "fields": {
                      "id": {
                        "type": "string",
                        "id": 10,
                        "rule": "optional"
                      },
                      "jobId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "locationId": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "teamMemberId": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "calendarEvent": {
                        "type": ".squareup.common.calendar.CalendarEvent",
                        "id": 4,
                        "rule": "optional"
                      },
                      "notes": {
                        "type": "string",
                        "id": 8,
                        "rule": "optional"
                      },
                      "published": {
                        "type": "bool",
                        "id": 5,
                        "rule": "optional"
                      },
                      "deleted": {
                        "type": "bool",
                        "id": 9,
                        "rule": "optional"
                      },
                      "createdAt": {
                        "type": "string",
                        "id": 6,
                        "rule": "optional"
                      },
                      "updatedAt": {
                        "type": "string",
                        "id": 7,
                        "rule": "optional"
                      },
                      "shiftCover": {
                        "type": ".squareup.timecards.scheduling.ShiftCover",
                        "id": 11,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "ShiftCover": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "shiftToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "shiftScheduleToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "status": {
                    "type": ".squareup.timecards.scheduling.ShiftCover.Status",
                    "id": 4,
                    "rule": "optional"
                  },
                  "acceptedEmployeeTokens": {
                    "type": "string",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "declinedEmployeeTokens": {
                    "type": "string",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "originalEmployeeToken": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "shiftScheduleVersionToken": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "successorEmployeeToken": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "updatedAt": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "successorShiftScheduleVersionToken": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Status": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "PENDING": 1,
                      "DECLINED": 2,
                      "APPROVED": 3,
                      "CANCELED": 4,
                      "EXPIRED": 5,
                      "OBSOLETE": 6
                    }
                  }
                }
              },
              "ConstraintViolation": {
                "fields": {
                  "localizedLongDescription": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "localizedShortDescription": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "severity": {
                    "type": ".squareup.timecards.scheduling.ConstraintViolation.Severity",
                    "id": 3,
                    "rule": "optional"
                  },
                  "type": {
                    "type": ".squareup.timecards.scheduling.ConstraintViolation.Type",
                    "id": 4,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Severity": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "SOFT": 1,
                      "MEDIUM": 2,
                      "HARD": 3
                    }
                  },
                  "Type": {
                    "values": {
                      "TYPE_DO_NOT_USE": 0,
                      "INACTIVE": 1,
                      "NO_JOB_ASSIGNED": 2,
                      "NO_LOCATION_ASSIGNED": 3,
                      "CONFLICTING_SHIFT": 4,
                      "TIME_OFF": 5,
                      "UNAVAILABLE": 6
                    }
                  }
                }
              },
              "ShiftScheduleConstraintViolationList": {
                "fields": {
                  "shiftScheduleId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "constraintViolations": {
                    "type": ".squareup.timecards.scheduling.ConstraintViolation",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "TeamMemberWorkweek": {
                "fields": {
                  "teamMemberId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "startDatetime": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "stopDatetime": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "shiftSchedules": {
                    "type": ".squareup.timecards.scheduling.ShiftSchedule",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "shiftScheduleTokensWithLatestVersionOutsideOfFilter": {
                    "type": "string",
                    "id": 7,
                    "rule": "repeated"
                  },
                  "constraintViolationList": {
                    "type": ".squareup.timecards.scheduling.ShiftScheduleConstraintViolationList",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "teamMember": {
                    "type": ".squareup.timecards.scheduling.TeamMember",
                    "id": 6,
                    "rule": "optional"
                  },
                  "byWorkdayCalculations": {
                    "type": ".squareup.timecards.scheduling.TeamMemberWorkweek.ByWorkdayCalculation",
                    "id": 8,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "ByWorkdayCalculation": {
                    "fields": {
                      "shiftScheduleId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "forecastLaborCost": {
                        "type": ".squareup.timecards.LaborCostTotal",
                        "id": 2,
                        "rule": "optional"
                      },
                      "workTimeRange": {
                        "type": ".squareup.common.calendar.CalendarEvent",
                        "id": 3,
                        "rule": "optional"
                      },
                      "calculationTotal": {
                        "type": ".squareup.timecards.CalculationTotal",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "TeamMember": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "givenName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "familyName": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "initials": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "personId": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "ShiftTemplate": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "merchantId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "jobId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "startTime": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "stopTime": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "notes": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "colorScheme": {
                    "type": ".squareup.timecards.scheduling.ColorScheme",
                    "id": 7,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "updatedAt": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  }
                }
              },
              "TimeOff": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "teamMemberId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "startDatetime": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "stopDatetime": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "note": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "state": {
                    "type": ".squareup.timecards.scheduling.TimeOff.State",
                    "id": 8,
                    "rule": "optional"
                  },
                  "localDateRange": {
                    "type": ".squareup.timecards.scheduling.LocalDateRange",
                    "id": 6
                  },
                  "zonedDateRange": {
                    "type": ".squareup.timecards.scheduling.ZonedDateRange",
                    "id": 7
                  }
                },
                "nested": {
                  "State": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "PENDING_AUTHORIZATION": 2,
                      "AUTHORIZED": 3,
                      "FORBIDDEN": 5,
                      "CANCELED": 6,
                      "OBSOLETE": 7
                    }
                  },
                  "date_range": {
                    "oneof": ["localDateRange", "zonedDateRange"]
                  }
                }
              },
              "TimeOffSnapshot": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "teamMemberId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "note": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "state": {
                    "type": ".squareup.timecards.scheduling.TimeOff.State",
                    "id": 6,
                    "rule": "optional"
                  },
                  "localDateRange": {
                    "type": ".squareup.timecards.scheduling.LocalDateRange",
                    "id": 4
                  },
                  "zonedDateRange": {
                    "type": ".squareup.timecards.scheduling.ZonedDateRange",
                    "id": 5
                  }
                },
                "nested": {
                  "date_range": {
                    "oneof": ["localDateRange", "zonedDateRange"]
                  }
                }
              },
              "TimeOffUpdate": {
                "fields": {
                  "timeOffSnapshot": {
                    "type": ".squareup.timecards.scheduling.TimeOffSnapshot",
                    "id": 1,
                    "rule": "optional"
                  },
                  "updateReason": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "actingTeamMemberId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "timestamp": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "LocalDateRange": {
                "fields": {
                  "startDatetime": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "stopDatetime": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "LocalDateTimeRange": {
                "fields": {
                  "startDatetime": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "stopDatetime": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ZonedDateRange": {
                "fields": {
                  "timezone": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "startTime": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "stopTime": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "TimeOffContext": {
                "fields": {
                  "timeOffId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "timeOffPerYear": {
                    "type": ".squareup.timecards.scheduling.TimeOffContext.TimeOffYearContext",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "otherTeamMembersApprovedOffThisPeriod": {
                    "type": "string",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "otherTeamMembersRequestingOffThisPeriod": {
                    "type": "string",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "shiftScheduleConflicts": {
                    "type": ".squareup.timecards.scheduling.ShiftSchedule",
                    "id": 5,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "TimeOffYearContext": {
                    "fields": {
                      "year": {
                        "type": "uint32",
                        "id": 1,
                        "rule": "optional"
                      },
                      "daysOffThisCalendarYear": {
                        "type": "uint32",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "OwnTimeOffContext": {
                "fields": {
                  "timeOffId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "timeOffPerYear": {
                    "type": ".squareup.timecards.scheduling.TimeOffContext.TimeOffYearContext",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "ScheduleFilterSettings": {
                "fields": {
                  "showOpenShifts": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "showAllTeamMembers": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "locationIds": {
                    "type": "string",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "showOtherJobs": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  },
                  "jobIds": {
                    "type": "string",
                    "id": 5,
                    "rule": "repeated"
                  }
                }
              },
              "SearchAllShiftsFilter": {
                "fields": {
                  "shiftLocalDateRangeToStartOfWorkday": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional",
                    "options": {
                      "default": true
                    }
                  },
                  "locationIds": {
                    "type": "string",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "shiftType": {
                    "type": ".squareup.timecards.scheduling.ShiftStatusType",
                    "id": 5,
                    "rule": "optional"
                  },
                  "startDate": {
                    "type": ".squareup.timecards.scheduling.LocalDateRange",
                    "id": 1
                  },
                  "startDateTime": {
                    "type": ".squareup.timecards.scheduling.LocalDateTimeRange",
                    "id": 2
                  }
                },
                "nested": {
                  "time_range": {
                    "oneof": ["startDate", "startDateTime"]
                  }
                }
              },
              "SearchAllShiftsQuery": {
                "fields": {
                  "filter": {
                    "type": ".squareup.timecards.scheduling.SearchAllShiftsFilter",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ShiftWithAlerts": {
                "fields": {
                  "shift": {
                    "type": ".squareup.timecards.scheduling.Shift",
                    "id": 1,
                    "rule": "optional"
                  },
                  "alerts": {
                    "type": ".squareup.timecards.scheduling.ShiftWithAlerts.AlertType",
                    "id": 2,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "AlertType": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "NO_SHOW": 1,
                      "CLOCKED_IN_LATE": 2,
                      "CLOCKED_OUT_LATE": 3,
                      "HAS_NOT_CLOCKED_IN": 4,
                      "ONGOING_SHIFT_SHOULD_END": 5
                    }
                  }
                }
              },
              "ShiftStatusCount": {
                "fields": {
                  "status": {
                    "type": ".squareup.timecards.scheduling.ShiftStatusType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "count": {
                    "type": "int32",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ShiftStatusType": {
                "values": {
                  "SHIFT_STATUS_TYPE_DO_NOT_USE": 0,
                  "ALERTS": 1,
                  "CLOCKED_IN": 2,
                  "SCHEDULED": 3,
                  "ON_BREAK": 4,
                  "CLOCKED_OUT": 5
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.timecards?.nested?.scheduling?.nested?.OpenShiftsFilter && !$root.nested?.squareup?.nested?.timecards?.nested?.scheduling?.nested?.ColorScheme && !$root.nested?.squareup?.nested?.timecards?.nested?.scheduling?.nested?.Shift && !$root.nested?.squareup?.nested?.timecards?.nested?.scheduling?.nested?.Shift?.nested?.Traits && !$root.nested?.squareup?.nested?.timecards?.nested?.scheduling?.nested?.Shift?.nested?.Traits?.nested?.Status && !$root.nested?.squareup?.nested?.timecards?.nested?.scheduling?.nested?.ShiftSchedule && !$root.nested?.squareup?.nested?.timecards?.nested?.scheduling?.nested?.ShiftSchedule?.nested?.Version && !$root.nested?.squareup?.nested?.timecards?.nested?.scheduling?.nested?.ShiftCover && !$root.nested?.squareup?.nested?.timecards?.nested?.scheduling?.nested?.ShiftCover?.nested?.Status && !$root.nested?.squareup?.nested?.timecards?.nested?.scheduling?.nested?.ConstraintViolation && !$root.nested?.squareup?.nested?.timecards?.nested?.scheduling?.nested?.ConstraintViolation?.nested?.Severity && !$root.nested?.squareup?.nested?.timecards?.nested?.scheduling?.nested?.ConstraintViolation?.nested?.Type && !$root.nested?.squareup?.nested?.timecards?.nested?.scheduling?.nested?.ShiftScheduleConstraintViolationList && !$root.nested?.squareup?.nested?.timecards?.nested?.scheduling?.nested?.TeamMemberWorkweek && !$root.nested?.squareup?.nested?.timecards?.nested?.scheduling?.nested?.TeamMemberWorkweek?.nested?.ByWorkdayCalculation && !$root.nested?.squareup?.nested?.timecards?.nested?.scheduling?.nested?.TeamMember && !$root.nested?.squareup?.nested?.timecards?.nested?.scheduling?.nested?.ShiftTemplate && !$root.nested?.squareup?.nested?.timecards?.nested?.scheduling?.nested?.TimeOff && !$root.nested?.squareup?.nested?.timecards?.nested?.scheduling?.nested?.TimeOff?.nested?.State && !$root.nested?.squareup?.nested?.timecards?.nested?.scheduling?.nested?.TimeOffSnapshot && !$root.nested?.squareup?.nested?.timecards?.nested?.scheduling?.nested?.TimeOffUpdate && !$root.nested?.squareup?.nested?.timecards?.nested?.scheduling?.nested?.LocalDateRange && !$root.nested?.squareup?.nested?.timecards?.nested?.scheduling?.nested?.LocalDateTimeRange && !$root.nested?.squareup?.nested?.timecards?.nested?.scheduling?.nested?.ZonedDateRange && !$root.nested?.squareup?.nested?.timecards?.nested?.scheduling?.nested?.TimeOffContext && !$root.nested?.squareup?.nested?.timecards?.nested?.scheduling?.nested?.TimeOffContext?.nested?.TimeOffYearContext && !$root.nested?.squareup?.nested?.timecards?.nested?.scheduling?.nested?.OwnTimeOffContext && !$root.nested?.squareup?.nested?.timecards?.nested?.scheduling?.nested?.ScheduleFilterSettings && !$root.nested?.squareup?.nested?.timecards?.nested?.scheduling?.nested?.SearchAllShiftsFilter && !$root.nested?.squareup?.nested?.timecards?.nested?.scheduling?.nested?.SearchAllShiftsQuery && !$root.nested?.squareup?.nested?.timecards?.nested?.scheduling?.nested?.ShiftWithAlerts && !$root.nested?.squareup?.nested?.timecards?.nested?.scheduling?.nested?.ShiftWithAlerts?.nested?.AlertType && !$root.nested?.squareup?.nested?.timecards?.nested?.scheduling?.nested?.ShiftStatusCount && !$root.nested?.squareup?.nested?.timecards?.nested?.scheduling?.nested?.ShiftStatusType) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE OpenShiftsFilter @ squareup/timecards/scheduling/models.proto at 14:1
 */
export const OpenShiftsFilter = $root.lookupEnum('squareup.timecards.scheduling.OpenShiftsFilter').values;
/**
 * SOURCE ColorScheme @ squareup/timecards/scheduling/models.proto at 25:1
 */
export const ColorScheme = $root.lookupEnum('squareup.timecards.scheduling.ColorScheme').values;
/**
 * SOURCE Shift @ squareup/timecards/scheduling/models.proto at 43:1
 */
export const Shift = $root.lookupType('squareup.timecards.scheduling.Shift');
fixType(Shift, {
  id: {
    notEmpty: true
  },
  traits: {
    required: true
  }
});
Builder.createAndAttachToType(Shift);
/**
 * next id: 6
 *
 * SOURCE Traits @ squareup/timecards/scheduling/models.proto at 52:3
 */
Shift.Traits = $root.lookupType('squareup.timecards.scheduling.Shift.Traits');
fixType(Shift.Traits, {
  status: {
    required: true
  }
});
Builder.createAndAttachToType(Shift.Traits);
/**
 * SOURCE Status @ squareup/timecards/scheduling/models.proto at 59:5
 */
Shift.Traits.Status = $root.lookupEnum('squareup.timecards.scheduling.Shift.Traits.Status').values;
/**
 * SOURCE ShiftSchedule @ squareup/timecards/scheduling/models.proto at 76:1
 */
export const ShiftSchedule = $root.lookupType('squareup.timecards.scheduling.ShiftSchedule');
fixType(ShiftSchedule, {
  merchantId: {
    notEmpty: true
  },
  latestVersion: {
    required: true
  }
});
Builder.createAndAttachToType(ShiftSchedule);
/**
 * next id = 10
 *
 * SOURCE Version @ squareup/timecards/scheduling/models.proto at 127:3
 */
ShiftSchedule.Version = $root.lookupType('squareup.timecards.scheduling.ShiftSchedule.Version');
fixType(ShiftSchedule.Version, {
  jobId: {
    notEmpty: true
  },
  locationId: {
    notEmpty: true
  },
  calendarEvent: {
    required: true
  },
  published: {
    required: true
  }
});
Builder.createAndAttachToType(ShiftSchedule.Version);
/**
 * SOURCE ShiftCover @ squareup/timecards/scheduling/models.proto at 161:1
 */
export const ShiftCover = $root.lookupType('squareup.timecards.scheduling.ShiftCover');
fixType(ShiftCover, {
  token: {
    notEmpty: true
  },
  shiftToken: {
    notEmpty: true
  },
  shiftScheduleToken: {
    notEmpty: true
  },
  originalEmployeeToken: {
    notEmpty: true
  },
  shiftScheduleVersionToken: {
    notEmpty: true
  },
  updatedAt: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ShiftCover);
/**
 * SOURCE Status @ squareup/timecards/scheduling/models.proto at 174:3
 */
ShiftCover.Status = $root.lookupEnum('squareup.timecards.scheduling.ShiftCover.Status').values;
/**
 * SOURCE ConstraintViolation @ squareup/timecards/scheduling/models.proto at 185:1
 */
export const ConstraintViolation = $root.lookupType('squareup.timecards.scheduling.ConstraintViolation');
fixType(ConstraintViolation, {
  localizedLongDescription: {
    notEmpty: true
  },
  localizedShortDescription: {
    notEmpty: true
  },
  severity: {
    required: true
  },
  type: {
    required: true
  }
});
Builder.createAndAttachToType(ConstraintViolation);
/**
 * SOURCE Severity @ squareup/timecards/scheduling/models.proto at 196:3
 */
ConstraintViolation.Severity = $root.lookupEnum('squareup.timecards.scheduling.ConstraintViolation.Severity').values;
/**
 * SOURCE Type @ squareup/timecards/scheduling/models.proto at 203:3
 */
ConstraintViolation.Type = $root.lookupEnum('squareup.timecards.scheduling.ConstraintViolation.Type').values;
/**
 * A list of constraint violations for a specific shift schedule.
 *
 * SOURCE ShiftScheduleConstraintViolationList @ squareup/timecards/scheduling/models.proto at 215:1
 */
export const ShiftScheduleConstraintViolationList = $root.lookupType('squareup.timecards.scheduling.ShiftScheduleConstraintViolationList');
fixType(ShiftScheduleConstraintViolationList, {
  shiftScheduleId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ShiftScheduleConstraintViolationList);
/**
 * SOURCE TeamMemberWorkweek @ squareup/timecards/scheduling/models.proto at 222:1
 */
export const TeamMemberWorkweek = $root.lookupType('squareup.timecards.scheduling.TeamMemberWorkweek');
fixType(TeamMemberWorkweek, {
  startDatetime: {
    notEmpty: true
  },
  stopDatetime: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(TeamMemberWorkweek);
/**
 * SOURCE ByWorkdayCalculation @ squareup/timecards/scheduling/models.proto at 249:3
 */
TeamMemberWorkweek.ByWorkdayCalculation = $root.lookupType('squareup.timecards.scheduling.TeamMemberWorkweek.ByWorkdayCalculation');
fixType(TeamMemberWorkweek.ByWorkdayCalculation, {
  shiftScheduleId: {
    notEmpty: true
  },
  forecastLaborCost: {
    required: true
  },
  workTimeRange: {
    required: true
  },
  calculationTotal: {
    required: true
  }
});
Builder.createAndAttachToType(TeamMemberWorkweek.ByWorkdayCalculation);
/**
 * SOURCE TeamMember @ squareup/timecards/scheduling/models.proto at 259:1
 */
export const TeamMember = $root.lookupType('squareup.timecards.scheduling.TeamMember');
fixType(TeamMember, {
  id: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(TeamMember);
/**
 * SOURCE ShiftTemplate @ squareup/timecards/scheduling/models.proto at 267:1
 */
export const ShiftTemplate = $root.lookupType('squareup.timecards.scheduling.ShiftTemplate');
fixType(ShiftTemplate, {
  merchantId: {
    notEmpty: true
  },
  jobId: {
    notEmpty: true
  },
  startTime: {
    notEmpty: true
  },
  stopTime: {
    notEmpty: true
  },
  colorScheme: {
    required: true
  }
});
Builder.createAndAttachToType(ShiftTemplate);
/**
 * SOURCE TimeOff @ squareup/timecards/scheduling/models.proto at 289:1
 */
export const TimeOff = $root.lookupType('squareup.timecards.scheduling.TimeOff');
fixType(TimeOff, {
  teamMemberId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(TimeOff);
/**
 * SOURCE State @ squareup/timecards/scheduling/models.proto at 311:3
 */
TimeOff.State = $root.lookupEnum('squareup.timecards.scheduling.TimeOff.State').values;
/**
 * Should match TimeOff, but might have different validations
 *
 * SOURCE TimeOffSnapshot @ squareup/timecards/scheduling/models.proto at 328:1
 */
export const TimeOffSnapshot = $root.lookupType('squareup.timecards.scheduling.TimeOffSnapshot');
fixType(TimeOffSnapshot, {
  teamMemberId: {
    notEmpty: true
  },
  state: {
    required: true
  }
});
Builder.createAndAttachToType(TimeOffSnapshot);
/**
 * SOURCE TimeOffUpdate @ squareup/timecards/scheduling/models.proto at 345:1
 */
export const TimeOffUpdate = $root.lookupType('squareup.timecards.scheduling.TimeOffUpdate');
fixType(TimeOffUpdate, {
  timeOffSnapshot: {
    required: true
  },
  timestamp: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(TimeOffUpdate);
/**
 * SOURCE LocalDateRange @ squareup/timecards/scheduling/models.proto at 353:1
 */
export const LocalDateRange = $root.lookupType('squareup.timecards.scheduling.LocalDateRange');
fixType(LocalDateRange, {
  startDatetime: {
    required: true
  },
  stopDatetime: {
    required: true
  }
});
Builder.createAndAttachToType(LocalDateRange);
/**
 * SOURCE LocalDateTimeRange @ squareup/timecards/scheduling/models.proto at 360:1
 */
export const LocalDateTimeRange = $root.lookupType('squareup.timecards.scheduling.LocalDateTimeRange');
fixType(LocalDateTimeRange, {
  startDatetime: {
    required: true
  },
  stopDatetime: {
    required: true
  }
});
Builder.createAndAttachToType(LocalDateTimeRange);
/**
 * SOURCE ZonedDateRange @ squareup/timecards/scheduling/models.proto at 366:1
 */
export const ZonedDateRange = $root.lookupType('squareup.timecards.scheduling.ZonedDateRange');
fixType(ZonedDateRange, {
  timezone: {
    required: true
  },
  startTime: {
    required: true
  },
  stopTime: {
    required: true
  }
});
Builder.createAndAttachToType(ZonedDateRange);
/**
 * SOURCE TimeOffContext @ squareup/timecards/scheduling/models.proto at 372:1
 */
export const TimeOffContext = $root.lookupType('squareup.timecards.scheduling.TimeOffContext');
fixType(TimeOffContext);
Builder.createAndAttachToType(TimeOffContext);
/**
 * SOURCE TimeOffYearContext @ squareup/timecards/scheduling/models.proto at 393:3
 */
TimeOffContext.TimeOffYearContext = $root.lookupType('squareup.timecards.scheduling.TimeOffContext.TimeOffYearContext');
fixType(TimeOffContext.TimeOffYearContext);
Builder.createAndAttachToType(TimeOffContext.TimeOffYearContext);
/**
 * SOURCE OwnTimeOffContext @ squareup/timecards/scheduling/models.proto at 399:1
 */
export const OwnTimeOffContext = $root.lookupType('squareup.timecards.scheduling.OwnTimeOffContext');
fixType(OwnTimeOffContext);
Builder.createAndAttachToType(OwnTimeOffContext);
/**
 * SOURCE ScheduleFilterSettings @ squareup/timecards/scheduling/models.proto at 406:1
 */
export const ScheduleFilterSettings = $root.lookupType('squareup.timecards.scheduling.ScheduleFilterSettings');
fixType(ScheduleFilterSettings);
Builder.createAndAttachToType(ScheduleFilterSettings);
/**
 * SOURCE SearchAllShiftsFilter @ squareup/timecards/scheduling/models.proto at 420:1
 */
export const SearchAllShiftsFilter = $root.lookupType('squareup.timecards.scheduling.SearchAllShiftsFilter');
fixType(SearchAllShiftsFilter);
Builder.createAndAttachToType(SearchAllShiftsFilter);
/**
 * SOURCE SearchAllShiftsQuery @ squareup/timecards/scheduling/models.proto at 438:1
 */
export const SearchAllShiftsQuery = $root.lookupType('squareup.timecards.scheduling.SearchAllShiftsQuery');
fixType(SearchAllShiftsQuery);
Builder.createAndAttachToType(SearchAllShiftsQuery);
/**
 * SOURCE ShiftWithAlerts @ squareup/timecards/scheduling/models.proto at 442:1
 */
export const ShiftWithAlerts = $root.lookupType('squareup.timecards.scheduling.ShiftWithAlerts');
fixType(ShiftWithAlerts);
Builder.createAndAttachToType(ShiftWithAlerts);
/**
 * SOURCE AlertType @ squareup/timecards/scheduling/models.proto at 443:3
 */
ShiftWithAlerts.AlertType = $root.lookupEnum('squareup.timecards.scheduling.ShiftWithAlerts.AlertType').values;
/**
 * SOURCE ShiftStatusCount @ squareup/timecards/scheduling/models.proto at 456:1
 */
export const ShiftStatusCount = $root.lookupType('squareup.timecards.scheduling.ShiftStatusCount');
fixType(ShiftStatusCount);
Builder.createAndAttachToType(ShiftStatusCount);
/**
 * SOURCE ShiftStatusType @ squareup/timecards/scheduling/models.proto at 460:1
 */
export const ShiftStatusType = $root.lookupEnum('squareup.timecards.scheduling.ShiftStatusType').values;